import { create } from "zustand";

import {
  DefaultListResponse,
  DefaultListStateType,
  DefaultPageState,
} from "../../../../common/models/StoreDefaultModel";
import { ActionsKey } from "../../../../common/models/Actions";
import { MissingDataModel } from "../core/_model";

export const initialPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};

export type ActionedMissingMaterial = {
  data: MissingDataModel | null;
  action: ActionsKey;
};

type MissinglDataType = {
  list: any;
  pageState: any;
  detail: MissingDataModel | null;
  actioned: ActionedMissingMaterial | null;
  totalItems?: number;
  setPageState: (detail: any | null) => void;
  setDetail: (detail: MissingDataModel | null) => void;
  setList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedMissingMaterial | null) => void;
  resetPageState: () => void;
};

export const useMissingStore = create<MissinglDataType>((set) => ({
  list: [],
  detail: null,
  actioned: null,
  pageState: initialPageState,

  totalItems: 0,
  setPageState: (pageState) => set((state) => ({ pageState })),
  resetPageState: () =>
    set(() => ({
      pageState: initialPageState,
    })),
  setDetail: (detail) => set((state) => ({ detail })),
  setList: (data) =>
    set((state) => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));
